import { API_URL } from "./apiBase";

export const getCompanyProfile = async (
  company_id: string,
  accessToken: string | null
) => {
  return fetch(`${API_URL}/company/${company_id}/profile`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }).then((res) => res.json());
};


